
export default {
  props: ['league'],
  components: {
    question: require("./question.vue").default,
  }
};